// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"d2ac567f","339":"b8229087","591":"17d67961"}[chunkId] + ".chunk.js";
};